// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8aa89ac1","902":"13172a7a"}[chunkId] + ".chunk.js";
};